import { BorderRadius, BorderWidth, BoxShadow, Breakpoint, Color, HorizontalFlex, Layer, LayoutContainerWidth, Space } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const BulkActionsBar = styled(HorizontalFlex)<{ $visible: boolean }>`
  background-color: ${Color.Neutral.V20};
  border: ${BorderWidth.V2} solid ${Color.Neutral.V40};
  border-radius: ${BorderRadius.V8};
  bottom: 23px;
  box-shadow: ${BoxShadow.V20};
  box-sizing: border-box;
  left: 0;
  margin: 0 auto;
  max-width: calc(100% - ${Space.V24} - ${Space.V24});
  padding-bottom: calc(${Space.V16} - ${BorderWidth.V2}) !important;
  padding-top: calc(${Space.V16} - ${BorderWidth.V2}) !important;
  pointer-events: ${(props) => (props.$visible ? "auto" : "none")};
  position: fixed;
  right: 0;
  transform: translateY(${(props) => (props.$visible ? "0" : "calc(100% + 40px)")});
  transition: transform 200ms ease-in-out;
  width: 100%;
  z-index: ${Layer.V40};

  @media (min-width: ${Breakpoint.S}) {
    width: ${LayoutContainerWidth.S};
  }

  @media (min-width: ${Breakpoint.M}) {
    width: ${LayoutContainerWidth.M};
  }

  @media (min-width: ${Breakpoint.L}) {
    width: ${LayoutContainerWidth.L};
  }

  @media (min-width: ${Breakpoint.XL}) {
    width: ${LayoutContainerWidth.XL};
  }

  @media (min-width: ${Breakpoint.XXL}) {
    width: ${LayoutContainerWidth.XXL};
  }
`;
